<template>
  <div class="container sidebar">
    <div class="header bottom-shadow">
      <label>Upcoming Races</label>
    </div>

    <div class="route-list">

      <div class="loader-container">
        <div class="loader" v-bind:class="{ 'loader-hide' : eventsLoaded }"></div>
      </div>

      <div class="race-row" v-show="event.published || showAdminContent" v-for="event in events" :key="event.key" v-on:click="selectEvent(event, event.key)" v-bind:class="{ 'highlighted' : selectedId == event.key }">

        <div class="length">
          <label>{{ event.path.length | decimal }}</label>
        </div>

        <div class="info">
          <label class="name">{{event.event.name}}</label>
          <label class="date">{{getEventDate(event.event.start)}}</label>
        </div>

        <div class="admin-buttons">

          <div v-show="selectedId === event.key && showAdminContent">
            <img v-show="event.published" src="../img/published.svg" v-on:click="togglePublish(event.key, event.published, event.event.name)"/>
            <img v-show="!event.published" src="../img/unpublished.svg" v-on:click="togglePublish(event.key, event.published, event.event.name)"/>
          </div>


          <div style="display:flex; flex-direction: row">

            <div style="margin-right: 5px" v-show="selectedId === event.key && showAdminContent">
              <img src="../img/btn_ownmessages.svg" v-on:click="editTemplatePoints(event)"/>
            </div>

            <div v-show="selectedId === event.key && showAdminContent">
              <img src="../img/delete.svg" v-on:click="deleteEvent(event.key, event.event.name)"/>
            </div>
          </div>
        </div>
        </div>
    </div>
    <div class="gpxImport">
      <p>Is your event not on the list? You can plot the route or import your own GPX route file below!</p>

      <label v-on:click="importGpx()">Import GPX</label>
      <label v-on:click="plotRoute()" class="plot">Plot a route</label>

    </div>
    <div class="gpxImport" v-show="showAdminContent">
      <p>No GPX?</p>

      <label v-on:click="createRouteWithoutGpx()">Create route without GPX</label>
      <label v-on:click="plotRoute()" class="plot">Plot a route</label>

    </div>

    <BottomNav @previousPage="previousPage()" @nextPage="nextPage()" pText="Back" pColor="blue" nText="Select" v-bind:nColor="nextColor" />
  </div>
</template>

<script>

import BottomNav from './BottomNav'
import axios from 'axios'
import moment from 'moment'
import firebase from 'firebase'
import { store } from '../store/store'
import { userRef, racePepsRef } from '../firebase'
import Vue from 'vue/dist/vue.js'
import _ from 'lodash'
import MapManager from '../helpers/mapManager'
import VuejsDialog from 'vuejs-dialog'
// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

const decimalFilter = function(value) {
  return (value/1000).toFixed(1)
}

export default {
  name: 'newRace',
  title: 'Runner - New Race',
  components: {
   BottomNav
  },
  filters: {
    decimal: decimalFilter
  },
  asyncComputed: {
    showAdminContent() {
      return new Promise((resolve, reject) => {
        firebase.auth().currentUser.getIdTokenResult()
        .then((idTokenResult) => {
          // Confirm the user is an Admin.
          if (idTokenResult.claims.admin) {
           resolve(true)
         } else {
           resolve(false)
         }
        })
        .catch((error) => {
          console.log(error)
          resolve(false)
        })
      })
    }
  },
  computed: {
    nextColor() {
      const color = this.selectedId ? "green" : "gray"
      return color
    }
  },
  data() {
    return {
      events: null,
      eventsLoaded: false,
      selectedId: null
    }
  },
  mounted() {
    this.getEvents()
  },
  methods: {
    previousPage() {
      this.$router.replace('menu')
    },
    nextPage() {
     if(this.selectedId) {
       this.chooseEvent()
     }
    },
    addEvent() {
      this.$router.replace({name: 'GpxImport', params: { 'addEvent': true } })
    },
    importGpx() {
     this.$router.replace('gpxImport')
    },
    plotRoute() {
     this.$router.replace('plotter')
    },
    createRouteWithoutGpx() {
              firebase.auth().currentUser.getIdToken().then((token) => {
          axios({
           method: 'post', //you can set what request you want to be
           url: 'https://us-central1-racepeps.cloudfunctions.net/api/processNoGpx',
           headers: {
             'Authorization': 'Bearer ' + token
           }
          })
          .then(response => {
            console.log(response)
            this.$router.replace('userRaces')
          })
              })
    },
    getEventDate(timestamp) {
      return moment(timestamp * 1000).format('D MMM YYYY')
    },
    getEvents() {
      firebase.database().ref('events').on('value', (snapshot) => {
        this.eventsLoaded = true

        if(snapshot.exists() && snapshot.val()) {
          //Order the returned events. The soonest event comes first
          var result = _(snapshot.val())
          .map(function(v, k) {
            return _.merge({}, v, { key: k });
          })
          .sortBy('event.start')
          .value();

          this.events = result
        }
      })
    },
    selectEvent(event, key) {
      console.log("event clicked", this.selectedId)
      if(key !== this.selectedId && key) {
        if(this.selectedId) {
          MapManager.clearMap()
        }
        this.selectedId = key
        MapManager.renderPath({ geoJson: event.path.encoded })
      } else {
        console.log("Event key was the same")
      }
    },
    chooseEvent() {
      console.log("chooseEvent")
      if(this.selectedId) {

        firebase.auth().currentUser.getIdToken().then((token) => {
          axios({
           method: 'post', //you can set what request you want to be
           url: 'https://us-central1-racepeps.cloudfunctions.net/event/event',
           data: {'eventId': this.selectedId},
           headers: {
             'Authorization': 'Bearer ' + token
           }
          })
          .then(response => {
            console.log(response)
            this.selectedId = null
            this.$store.dispatch('setRaceRef', { 'ref': userRef.child(firebase.auth().currentUser.uid).child('races').child(response.data.id),'isEvent': true }).then(() => {
              this.$router.replace('information')
            }).catch((err) => {
              console.log(err)
            })
          })
          .catch(error => {
            this.eventsLoaded = true
            console.log(error)
          })
        })
    }
  },
  deleteEvent(key, name) {

    // Trigger a confirmation dialog
    this.$dialog.confirm('Do you want to delete event ' + name + '?', { okText: 'Delete', cancelText: 'Close', backdropClose: true })
    .then((dialog) => {
      firebase.database().ref('events').child(key).remove().then(response => {
        if(this.selectedId) {
          MapManager.clearMap()
        }
        this.selectedId = null
      }).catch(error => {
        console.log(error)
        alert("Couldn't delete race")
      })
    })
    .catch(function() {
      console.log('Clicked on cancel')
    })

  },
  togglePublish(key, isPublic, name) {
    var msg = isPublic ? "Do you want to unpublish event " + name + "? The event won't be shown to the users." :'Do you want to publish event ' + name + '? Published events will be shown to all users.'
    var confirmMsg = isPublic ? 'Unpublish' : 'Publish'
    this.$dialog.confirm(msg, { okText: confirmMsg, cancelText: 'Close', backdropClose: true })
    .then((dialog) => {
      firebase.database().ref('events').child(key).update({'published': !isPublic}).then(response => {
        console.log('published set to ' + !isPublic)
      }).catch(error => {
        console.log(error)
        alert("Couldn't update publishing")
      })
    })
    .catch(function() {
      console.log('Clicked on cancel')
    })
  },
  editTemplatePoints(event) {
    firebase.database().ref('/aliases/').child(event.alias).once('value').then((snapshot) => {
      if(snapshot.exists()) {
        MapManager.clearMap()
        this.$store.dispatch('setRaceRef', {'ref': racePepsRef.child(snapshot.val()), 'myRaces': true, 'eventEdit': true }).then(() => {
          this.$store.dispatch('initInformation').then(() => {

            console.log("Information loading is done. routing to myracesinformation")
            if (event.hasOwnProperty('noPath')) {
              this.$store.dispatch('updateIsDistance', true)
              } else {
              this.$store.dispatch('updateIsDistance', false)
              }
            this.$router.replace('myracesinformation')

          })
       })

     }
  })

}
},
}

</script>

<style lang="scss" scoped>
  @import '../styles/styles.scss';

  .routeList {
    display: flex;
    flex: 4;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: $font-semiSemiLarge;
    color: $cyan;
    background-color: white;
  }

  .gpxImport {
    display: flex;
    flex: 1;
    flex-direction: column;
    background-color: #F5F5F7;
    text-align: center;
    justify-content: center;
    padding-left: 20%;
    padding-right: 20%;

    p {
      font-size: $font-semiSemiLarge;
      color: $greyer;
    }

    label {
      font-size: $font-large;
      font-weight: bold;
      color: $cyan;
      text-decoration: underline;
      cursor: pointer;
    }
    label.plot {
      margin-top:20px;
    }
  }

  .header {
    height: 80px;
    border-bottom: 1px solid gray;
  }

  .add-event-container {
    display: flex;
    justify-content: flex-end;
    padding-right: 10px;

    img {
      cursor: pointer;
    }
  }

  .route-list {
	   overflow-y: auto;
	   overflow-x: hidden;
     flex:1;
   }

   .race-row {
     display: flex;
     justify-content: space-between;
     flex-direction: row;
     width: 100%;
     height: 80px;
     padding: 20px 10px;
     border-bottom: solid 1px gray;
     cursor: pointer;

     label {
       cursor: pointer;
     }
   }

   .info {
     display: flex;
     flex-direction: column;
     flex: 1;
     font-size: 17px;

     .date {
       margin-top: 3px;
       opacity: 0.5;
       font-size: $font-medium;
     }
   }

   .admin-buttons {
     display: flex;
     align-items: flex-end;
     flex-direction: column;

      img {
       width: 25px;
       height: 25px;
       cursor: pointer;
      }

   }


   .length {
     border-radius: 50%;
   	 width: 48px;
   	 height: 48px;
     background-color:#a8c545;
     display: flex;
     align-self: center;
     justify-content: center;
     color: white;
     align-items: center;
     font-size: $font-semiSemiLarge;
     margin-right: 20px;

     cursor: pointer;

     label {
       cursor: pointer;
     }
   }

   .container.sidebar {
     background-color: #F2F2F2;
   }

   .highlighted {
     background-color: white;
   }

</style>
